
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center px-4">
      <h1 className="text-9xl font-extrabold text-gray-300">404</h1>
      <h2 className="mt-4 text-4xl font-bold text-gray-800">
        Oops! Page Not Found.
      </h2>
      <p className="mt-2 text-justify text-gray-600">
        The page you're looking for does not exist, has been moved or permanantly removed.
      </p>
      <Link
        to="/"
        className="mt-6 px-6 py-3 bg-purple-800 text-white rounded-md hover:bg-purple-700 transition-colors"
      >
        Go Home
      </Link>
    </div>
  );
};

export default NotFoundPage;
